import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AssistantBubble from "./components/AssistantBubble";

import Home from "./pages/Home";
import Episodes from "./pages/Episodes";
import EpisodeDetail from "./pages/EpisodeDetail";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import Directory from "./pages/Directory";
import MemberDetail from "./pages/MemberDetail";
import Subscribe from "./pages/Subscribe";
import SubscribeSuccess from "./pages/SubscribeSuccess";
import ApparelPreview from "./pages/ApparelPreview";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Admin from "./pages/Admin";
import Partners from "./pages/Partners";
import Funding from "./pages/Funding";
import FundingCompare from "./pages/FundingCompare";
import FundingApply from "./pages/FundingApply";
import FundingReport from "./pages/FundingReport";
import Franchise from "./pages/Franchise";
import FranchiseCompare from "./pages/FranchiseCompare";
import FranchiseCheckout from "./pages/FranchiseCheckout";
import About from "./pages/About";
import Vlog from "./pages/Vlog";
import Contact from "./pages/Contact";
import Affiliate from "./pages/Affiliate";
import SystemStatus from "./pages/SystemStatus";
import InstallApp from "./pages/InstallApp";
import Terms from "./pages/legal/Terms";
import Privacy from "./pages/legal/Privacy";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import CreditReadiness from "./pages/CreditReadiness";
import CreditReadinessApply from "./pages/CreditReadinessApply";
import CreditReadinessReport from "./pages/CreditReadinessReport";
import Newsletter from "./pages/Newsletter";
import NewsletterIssue from "./pages/NewsletterIssue";
import Lead from "./pages/Lead";
import Embed from "./pages/Embed";
import License from "./pages/License";
import LicenseSuccess from "./pages/LicenseSuccess";
import LicenseDashboard from "./pages/LicenseDashboard";
import BrandKitAccess from "./pages/BrandKitAccess";

const TOAST_OPTIONS = {
  style: {
    background: "#121418",
    border: "1px solid rgba(242,239,233,0.15)",
    color: "#F2EFE9",
    fontFamily: "Manrope, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main className="relative" style={{ zIndex: 2 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/episodes" element={<Episodes />} />
              <Route path="/episodes/:id" element={<EpisodeDetail />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/articles/:id" element={<ArticleDetail />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/directory/:id" element={<MemberDetail />} />
              <Route path="/subscribe" element={<Subscribe />} />
              <Route path="/subscribe/success" element={<SubscribeSuccess />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/funding" element={<Funding />} />
              <Route path="/funding/compare" element={<FundingCompare />} />
              <Route path="/funding/apply" element={<FundingApply />} />
              <Route path="/funding/report" element={<FundingReport />} />
              <Route path="/franchise" element={<Franchise />} />
              <Route path="/franchise/compare" element={<FranchiseCompare />} />
              <Route path="/franchise/checkout" element={<FranchiseCheckout />} />
              <Route path="/about" element={<About />} />
              <Route path="/vlog" element={<Vlog />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/affiliate" element={<Affiliate />} />
              <Route path="/status" element={<SystemStatus />} />
              <Route path="/install" element={<InstallApp />} />
              <Route path="/legal/terms" element={<Terms />} />
              <Route path="/legal/privacy" element={<Privacy />} />
              <Route path="/payments/success" element={<PaymentSuccess />} />
              <Route path="/payments/cancel" element={<PaymentCancel />} />
              <Route path="/credit-readiness" element={<CreditReadiness />} />
              <Route path="/credit-readiness/apply" element={<CreditReadinessApply />} />
              <Route path="/credit-readiness/report/:id" element={<CreditReadinessReport />} />
              <Route path="/newsletter" element={<Newsletter />} />
              <Route path="/newsletter/:slug" element={<NewsletterIssue />} />
              <Route path="/lead" element={<Lead />} />
              <Route path="/embed" element={<Embed />} />
              <Route path="/license" element={<License />} />
              <Route path="/license/success" element={<LicenseSuccess />} />
              <Route path="/license/dashboard" element={<LicenseDashboard />} />
              <Route path="/brand-kit-access" element={<BrandKitAccess />} />
              <Route path="/apparel-preview" element={<ApparelPreview />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <AssistantBubble />
          <Toaster theme="dark" position="bottom-right" toastOptions={TOAST_OPTIONS} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
